/**
 * Checks if this feature is available for the current organization.
 */

import { useGeneralizer } from "@/components/Generalizer";
import ForbiddenPage from "@/components/ui/ForbiddenPage/ForbiddenPage";
import { FeatureAvailability } from "@/constants/featureAvailability";
import React from "react";

export default function AvailableForOrgGuard({ featureName, children }) {
  const featureAvailability = FeatureAvailability[featureName];

  const isFeatureAvailable = useGeneralizer(featureAvailability, false);

  return <>{isFeatureAvailable == null ? <></> : isFeatureAvailable ? children : <ForbiddenPage />}</>;
}
